<script lang="ts">
    import { slide } from "svelte/transition";

    export let preset_name : string;
</script>

<div transition:slide>
    <h3>STEP 1. プリセット名を入力</h3>
    <p>VRoidStudioソフト内で表示されるプリセット名を入力してください。</p>
    <input id='preset_name' name="preset_name" type="text" placeholder='mixed-preset' bind:value={preset_name} />
</div>